module.exports = __webpack_public_path__ + "static/media/play.f2adc809.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.svg
// module id = 143
// module chunks = 0